import { Component, OnInit } from '@angular/core';
import { PortalManagementSubscriptionService } from 'src/app/features/portal/_services/management/portal-management-subscription.service';
import { FormBuilder, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { FormFields } from 'src/app/_share/_models/forms/form-fields.interface';
import { AuthorizationService } from 'src/app/_core/_services/authorization.service';

@Component({
  selector: 'app-cancel-subscription-dialog',
  templateUrl: './cancel-subscription-dialog.component.html',
  styleUrls: ['./cancel-subscription-dialog.component.scss']
})
export class CancelSubscriptionDialogComponent implements OnInit {
  cancelData: any;
  loading = false;

  constructor(
    private pmss: PortalManagementSubscriptionService,
    private fb: FormBuilder,
    public config: DynamicDialogConfig,
    public ref: DynamicDialogRef,
    public authz: AuthorizationService
  ) {}

  cancelFormFields: FormFields[] = [
    {
      name: 'cancellation_selected_reason',
      label: 'Reason for Cancellation',
      type: 'select',
      placeholder: 'Select a reason',
      validators: { required: { required: true } },
      rendered: true,
      valueOptions: [
        { label: 'Too expensive / Cost too high', value: 'too_expensive' },
        { label: 'Switching to another provider', value: 'switching_provider' },
        { label: 'Moving / Relocating', value: 'relocating' },
        { label: 'Service quality issues', value: 'service_quality' },
        { label: 'No longer needed', value: 'no_longer_needed' },
        { label: 'Customer request (no reason given)', value: 'customer_request' },
        { label: 'Other', value: 'other' }
      ]
    },
    {
      name: 'cancellation_reason',
      label: 'Additional Notes',
      type: 'textarea',
      placeholder: 'Please provide a reason for cancellation',
      validators: { required: { required: true } },
      rendered: true
    }
  ];

  ngOnInit(): void {
    this.cancelData = this.config.data;
  }

  onSubmit(formSubmission: any) {
    this.loading = true;
    this.pmss.cancelSubscription(this.cancelData.subscriptionId, formSubmission).subscribe({
      next: (res) => {
        console.log('Cancellation response: ', res);
        this.loading = false;
        this.ref.close({ success: true, data: res });
      },
      error: (err) => {
        console.error('Cancellation error: ', err);
        this.loading = false;
        this.ref.close({ success: false, error: err });
      }
    });
  }

  closeDialog() {
    this.ref.close();
  }
}
